import React from 'react'
import { withTranslation as translate } from 'react-i18next'

class MobileDropDown extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {
      currentOption: null,
      active: false,
    }
    this.onDefaultClick = this.onDefaultClick.bind(this)

    // const optionObjs = this.getOptionsData()
    // this.options = optionObjs.map((option,index) => {
    //   return (
    //     <li key={option.mobilityClass} onClick={this.onOptionClick.bind(this, option)}>
    //       <div className={'icon ' + option.iconClass}></div>
    //       <div className='mobile-dropdown-text' id={"mobile-dropdown-id " + index}>
    //         <h4>{option.title}</h4>
    //         <p>{option.description}</p>
    //       </div>
    //     </li>
    //   )
    // })
  }

  componentDidUpdate(){
    if (this.state.active) {
      document.body.onclick = e => {
        // For clicks inside dropdown, no action, otherwise, dismiss
        if (e.target.id==='mobile-drop-down-wrapper' ||
         e.target.parentElement.id==='mobile-drop-down' ||
         e.target.className==='mobile-dropdown-text' ||
         e.target.parentElement.className==='mobile-dropdown-text'

        ) {
          return false
        }
        else {
          this.setState({active: false})
        }
      }
    }
  }

  getOptionsData(){
    const _t = this.props.t
    return [
      {
        mobilityClass: 1,
        iconClass: 'mobile-icon1',
        description: _t('mobile_dropdown_category_1_description'),
        title: _t('landing_page_category_1_header')
      },
      {
        mobilityClass: 2,
        iconClass: 'mobile-icon2',
        description: _t('mobile_dropdown_category_2_description'),
        title: _t('landing_page_category_2_header')
      },
      {
        mobilityClass: 3,
        iconClass: 'mobile-icon3',
        description: _t('mobile_dropdown_category_3_description'),
        title: _t('landing_page_category_3_header')
      }
    ]
  }

  onOptionClick(option){
    // Set new default
    if (this.props.onChange) {
      this.props.onChange(option.mobilityClass)
    }
  }

  onDefaultClick(e){
    this.setState({active: !this.state.active})
  }

  getCurrentValue(){
    if (isNaN(this.props.value)) {
      return 0
    }

    return Math.max(Math.min(this.props.value, 3), 0)
  }

  render(){
    const _t = this.props.t
    const val = this.getCurrentValue()
    let currOption = null;

    const optionObjs = this.getOptionsData()
    this.options = optionObjs.map((option,index) => {
      return (
        <li key={option.mobilityClass} onClick={this.onOptionClick.bind(this, option)}>
          <div className={'icon ' + option.iconClass}></div>
          <div className='mobile-dropdown-text' id={"mobile-dropdown-id " + index}>
            <h4>{option.title}</h4>
            <p>{option.description}</p>
          </div>
        </li>
      )
    })

    if (val < 1) {
      currOption = (
        <div className='current-option'>
          <span>{_t('landing_page_mobility_header')}</span>
        </div>
      )
    }
    else {
      const optionObjs = this.getOptionsData()
      currOption = (
        <div className='current-option non-default'>
          <div className={'icon ' + optionObjs[val-1].iconClass}></div>
          <span>{optionObjs[val-1].title}</span>
        </div>
      )
    }

    let className = 'mobile-drop-down-wrapper ' + (this.props.showError ? 'err' : '')
    if (this.props.className) {
      className += ' ' + this.props.className
    }
    if (this.state.active){
      className = 'mobile-drop-down-wrapper focus-class' + (this.props.showError ? 'err' : '')
    }

    return (
      <div
        id='mobile-drop-down-wrapper'
        className={className}
        onClick={this.onDefaultClick}>
        {currOption}
        <ul
          id='mobile-drop-down'
          className={'mobile-drop-down' + (this.state.active ? ' active' : '')}>
          {this.options}
        </ul>
      </div>
    )
  }
}

export default translate()(MobileDropDown)
